import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileNumericStepperControlView {

    constructor() { }

    afterRender(control){
        let element = mobileAdjustment.adjustMobileControl(control);
        const height = mobileAdjustment.calculateHeight(control);

        element.find("div:first").css({"height": `${height}px`, 
                                        "width": '80%',
                                        "line-height": "normal"});
        element.find("a").css("width", '20%');
        element.find("span").css({"font-size": `${control.model.get('fontSize')}px`, "float": "left"});
    }
}

const mobileNumericStepperControlView = new MobileNumericStepperControlView();
export default mobileNumericStepperControlView;